import {
  addTipApi,
  updateTipApi,
  fetchTipsListApi,
  deleteTipApi,
  fetchTipsCategoryApi,
  fetchTipsCriteriaApi,
  fetchDeliveryMethodApi,
} from "services/tipsService";

import {
  fetchSingleTipData,
  fetchTipsData,
  setPagination,
  setTipLoader,
  tipSuccessMsg,
  tipErrorMsg,
  fetchTipsCategories,
  fetchTipsCriteria,
  fetchDeliveryMethods,
} from "./reducer";

export const fetchTips = (params: any) => async (dispatch: any) => {
  dispatch(setTipLoader(true));

  try {
    const response = await fetchTipsListApi(params);

    if (response?.success) {
      const list = response?.data?.tips || [];
      const pagination = response?.data?.pagination || {};

      // If fetching a single tip
      if (params.tip_id && params.tip_id !== 0) {
        dispatch(fetchSingleTipData({ single: list[0] }));
      } else {
        dispatch(fetchTipsData({ list, pagination }));
      }

      // Always update pagination
      dispatch(setPagination(pagination));
    }
  } catch (error: any) {
    dispatch(
      tipErrorMsg({
        message: error?.message || "Something went wrong",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setTipLoader(false));
  }
};


export const addTip = (tipData: any) => async (dispatch: any) => {
  dispatch(setTipLoader(true));

  try {
    const response = await addTipApi(tipData);

    if (response?.success) {
      dispatch(
        tipSuccessMsg({
          message: response.message || "Tip added successfully",
          id: Date.now(),
        })
      );
    } else {
      dispatch(
        tipErrorMsg({
          message: response?.message || "Failed to add tip",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      tipErrorMsg({
        message: error?.message || "Something went wrong while adding tip",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setTipLoader(false));
  }
};

export const updateTip =
  (tip_id: number, tipData: any) => async (dispatch: any) => {
    dispatch(setTipLoader(true));

    try {
      const response = await updateTipApi(tip_id, tipData);

      if (response?.success) {
        dispatch(
          tipSuccessMsg({
            message: response.message || "Tip updated successfully",
            id: Date.now(),
          })
        );
      } else {
        dispatch(
          tipErrorMsg({
            message: response?.message || "Failed to update tip",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        tipErrorMsg({
          message: error?.message || "Something went wrong while updating tip",
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setTipLoader(false));
    }
  };

export const deleteTip = (tip_id: number) => async (dispatch: any) => {
  dispatch(setTipLoader(true));

  try {
    const response = await deleteTipApi(tip_id);

    if (response?.success) {
      dispatch(
        tipSuccessMsg({
          message: response.message || "Tip deleted successfully",
          id: Date.now(),
        })
      );
    } else {
      dispatch(
        tipErrorMsg({
          message: response?.message || "Failed to delete tip",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      tipErrorMsg({
        message: error?.message || "Something went wrong while deleting tip",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setTipLoader(false));
  }
};

export const getTipsCategoryAdmin = () => async (dispatch: any) => {
  try {
    const res = await fetchTipsCategoryApi();

    if (res?.success && res.data) {
      const arr = Array.isArray(res.data) ? res.data : [res.data];
      dispatch(fetchTipsCategories(arr));

    }

  } catch (error) {
    dispatch(
      tipErrorMsg({ message: "Failed to load categories", id: Date.now() })
    );
  }
};


export const getTipsCriteriaAdmin = () => async (dispatch: any) => {
  try {
    const res = await fetchTipsCriteriaApi();

    if (res?.success) {
      const criteriaArray = Array.isArray(res.data) ? res.data : [res.data];
      dispatch(fetchTipsCriteria(criteriaArray));

    }
  } catch (error) {
    dispatch(tipErrorMsg({ message: "Failed to load criteria", id: Date.now() }));
  }
};

export const getTipsDeliveryMethodAdmin = () => async (dispatch: any) => {
  try {
    const res = await fetchDeliveryMethodApi();

    if (res?.success) {
      const methodArray = Array.isArray(res.data) ? res.data : [res.data];
      dispatch(fetchDeliveryMethods(methodArray));
    }
  } catch (error) {
    dispatch(tipErrorMsg({ message: "Failed to load delivery method", id: Date.now() }));
  }
};

